<template>
  <layout-component>
    <div class="banner banner-booking-success">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
            <p>{{ 'text-01'|t }}</p>

            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0'" to="/book" active-class="active"><span>{{ 'title-btn'|t }}</span></router-link>

          </div>
          </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      }
    }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Your account</span></span> <span class='title-anim-wrapper'><span class='title-anim'>is created!</span></span>",
        "text-01": "Please go to your mailbox to confirm your account.",
        "title-btn": "Book a room"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Votre compte</span></span> <span class='title-anim-wrapper'><span class='title-anim'>est cree !</span></span>",
        "text-01": "Veuillez consulter votre boîte mail pour confirmer votre compte.",
        "title-btn": "Reserver une salle"
      }
    }

  </i18n>
